import { ActivatedRoute } from '@angular/router';
import { ApplicationService } from 'src/app/core/services/application.service';
import { Component, OnInit, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { Application } from 'src/app/core/models/application';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ApplicationFilesInfoComponent } from '../../modals/application-files-info/application-files-info.component';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { UserRoleNames } from '../../../../core/models/users';
import { CustomAction } from 'src/app/core/models/customAction';
import { CustomActionComponent } from '../../modals/custom-action/custom-action.component';
import { ConfirmDialogComponent } from 'src/app/modules/shared/components/confirm-dialog/confirm-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-application-details',
  templateUrl: './application-details.component.html',
  styleUrls: ['./application-details.component.scss'],
})
export class ApplicationDetailsComponent implements OnInit, OnDestroy {

  passVisible: boolean = false;
  dataLoaded: boolean = false;
  application: Application;
  appDetailsSub: Subscription;
  multiExeFile = []
  multiLicenseFile = []
  multiResumeFile = []
  multiCancelFile = []
  multiSuspendFile = []
  multiGraphFiles = []
  multiCustomActionFiles = [];
  currentUser = this.authenticationService.currentUserValue;
  isMonitor: boolean = this.currentUser.role == UserRoleNames.Reader ? true : false;
  isGlobalAdmin: boolean = this.currentUser.role == UserRoleNames.GlobalAdmin;
  customActions: CustomAction[] = [];
  subscription : Subscription;
  
  constructor(
    private applicationService: ApplicationService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private snackbar: MatSnackBar,
    private elementRef: ElementRef
  ) { 
    this.subscription = this.applicationService.customActionAdded$
      .subscribe(() => {
        this.customActions = [];
        this.loadCustomActions();
      });
  }

  ngOnInit(): void {
    this.appDetailsSub = this.applicationService.SelectedApplication.subscribe((x) => {
      this.multiLicenseFile = [];
      this.multiExeFile = [];
      this.multiGraphFiles = [];
      this.multiResumeFile = [];
      this.multiCancelFile = [];
      this.multiSuspendFile = [];
      this.multiCustomActionFiles = [];
      if (x) { 
        this.customActions = [];
        this.loadAppDetails(x);
      }
    });
  }
  
  ngAfterViewInit() {
    this.adjustHeight();
  }

  loadAppDetails(data) {
    this.application = <Application>JSON.parse(JSON.stringify(data));
    if (this.application.executeFile != null && this.application.executeFile.includes(',')) {
      this.multiExeFile = this.application.executeFile.split(',')
    } else {
      this.multiExeFile.push(this.application.executeFile)
    }
    if (this.application.licenseFile != null && this.application.licenseFile.includes(',')) {
      this.multiLicenseFile = this.application.licenseFile.split(',')
    } else {
      this.multiLicenseFile.push(this.application.licenseFile)
    }
    if (this.application.resumeFile != null && this.application.resumeFile.includes(',')) {
      this.multiResumeFile = this.application.resumeFile.split(',')
    } else { this.multiResumeFile.push(this.application.resumeFile) }

    if (this.application.cancelFile != null && this.application.cancelFile.includes(',')) {
      this.multiCancelFile = this.application.cancelFile.split(',')
    } else { this.multiCancelFile.push(this.application.cancelFile) }

    if (this.application.suspendFile != null && this.application.suspendFile.includes(',')) {
      this.multiSuspendFile = this.application.suspendFile.split(',')
    } else { this.multiSuspendFile.push(this.application.suspendFile) }

    if (this.application.graphFiles != null && this.application.graphFiles.includes(',')) {
      this.multiGraphFiles = this.application.graphFiles.split(',')
    } else {
      this.multiGraphFiles.push(this.application.graphFiles)
    }

    if (this.application.customActionFile != null && this.application.customActionFile.includes(',')) {
      this.multiCustomActionFiles = this.application.customActionFile.split(',')
    } else {
      this.multiCustomActionFiles.push(this.application.customActionFile)
    }

    this.dataLoaded = true;

    this.loadCustomActions();
  }

  ngOnDestroy() {
    this.appDetailsSub?.unsubscribe();
    if(this.subscription)
      this.subscription.unsubscribe();
  }

  passValue = 'password';
  togglePass() {
    if (!this.passVisible) {
      this.passVisible = !this.passVisible;
      this.passValue = 'text';
    } else {
      this.passVisible = !this.passVisible;
      this.passValue = 'password';
    }
  }

  showMessageDialog(fileType: string){
    this.dialog.open(ApplicationFilesInfoComponent, {
      autoFocus: false,
      disableClose: true,
      width: '35%',
      data: {
        applicationId: this.application.appId,
        fileType: fileType
      }
    })
  }
  
  loadCustomActions() {
    this.customActions = [];
    this.applicationService.getCustomActionByAppId(
      this.application.depName, this.currentUser.username,
      this.application.appName, this.application.appVersionText,
      this.application.appId)
      .subscribe({
        next: (response) => {
          if (response && Array.isArray(response)) {
              this.customActions = response as CustomAction[];
          } else {
              this.customActions = [];
          }
        },
        error: (error) => {
          console.error('Error loading custom actions:', error);
          this.customActions = [];
        }
      })
  }

  optionsForActions(action: CustomAction, optionType: string) {
    
    // var newCustomAction: CustomAction = new CustomAction();
    // newCustomAction.actionName = action.actionName;
    // newCustomAction.appId = action.appId;
    // newCustomAction.id = action.id;
    // newCustomAction.param = action.param
    if(optionType.toLocaleLowerCase() === "edit"){
      this.dialog.open(CustomActionComponent, {
        width: '40vw',
        autoFocus: false,
        disableClose: true,
        data: { 
          depName: this.application.depName,
          userId: this.currentUser.username,
          dialogHeader: 'Update Custom Action',
          application: this.application,
          customAction: action,
        } 
        }).afterClosed().subscribe({
          next: (response) => {
            if(response === "Updated"){
              // This time out is for the delay in loading so that the update request is complete and then we fetch the updated Custom Actions
              setTimeout(()=>{
                this.customActions = [];
                this.loadCustomActions();
                this.snackbar.open('Custom Action Updated Successfully', 'OK', {
                  duration: 5000,
                });
              }, 1000);
            }
            else if(response === "Failed"){
              this.snackbar.open('Failed to Update Custom Action', 'OK', {
                duration: 5000,
              });
            }
          },
          error: (error) => {
            console.error('Error updating custom action:', error);
          }
        })
    }
    else if(optionType.toLowerCase() === "delete" ){
      this.dialog.open(ConfirmDialogComponent,{
        width: '40vw',
        disableClose: true,
        data: {
          titleMessage: 'Delete Custom Action',
          bodyMessage: `Are you sure you want to delete custom action '${action.actionName}'`,
          submitText: 'Delete',
          cancelText: 'Cancel',
          }
      }).afterClosed().subscribe({
        next: (response) => {
          if (response) {
            this.applicationService.deleteCustomAction(this.application.depName,
                this.currentUser.username,this.application.appName,
                this.application.appVersionText,action.appId,action.id)
            .subscribe({
              next: (response) => {
                this.snackbar.open("Deleted Custom Action Successfully","OK",{
                  duration: 5000
                })
                this.customActions = [];
                this.loadCustomActions();
              },
              error: (error) => {
                this.snackbar.open("Failed to Deleted Custom Action","OK",{
                  duration: 5000
                })
              }
            });
            }
          },
          error: (error) => {
            console.error('Error deleting custom action:', error);
          }
      });
    }
  }

  @HostListener('window:resize')
  adjustHeight() {
    const element = this.elementRef.nativeElement.querySelector('.node-details-container');
    if (element) {
      const rect = element.getBoundingClientRect();
      const topDistance = rect.top;
      const windowHeight = window.innerHeight;
      const availableHeight = windowHeight - topDistance;
      element.style.height = `${availableHeight - 20}px`;
    }
  }
}
